/**
 * @generated SignedSource<<39f905e1bd932344cbc7edd377d8646c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftExhibitionTileGrid_cmsNftExhibitionPage$data = {
  readonly featuredItemsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayOrder: number | null;
        readonly displayRow: number | null;
        readonly nftItem: {
          readonly creatorAddress: {
            readonly publicProfile: {
              readonly profileName: string | null;
            } | null;
          } | null;
          readonly metadata: {
            readonly name?: string | null;
          } | null;
          readonly mostRecentAuction: {
            readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
          } | null;
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem">;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly urlLabel: string | null;
  readonly " $fragmentType": "NftExhibitionTileGrid_cmsNftExhibitionPage";
};
export type NftExhibitionTileGrid_cmsNftExhibitionPage$key = {
  readonly " $data"?: NftExhibitionTileGrid_cmsNftExhibitionPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftExhibitionTileGrid_cmsNftExhibitionPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftExhibitionTileGrid_cmsNftExhibitionPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "NftCmsExhibitionFeaturedItemsConnectionConnection",
      "kind": "LinkedField",
      "name": "featuredItemsConnection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftCmsExhibitionFeaturedItemsConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftCmsExhibitionFeaturedItemResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayRow",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayOrder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NftItem",
                  "kind": "LinkedField",
                  "name": "nftItem",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EthereumAddressType",
                      "kind": "LinkedField",
                      "name": "creatorAddress",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PublicProfile",
                          "kind": "LinkedField",
                          "name": "publicProfile",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "profileName",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "metadata",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            }
                          ],
                          "type": "NftDigitalArtMetadata",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NftItemTile_nftItem"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NftAuction",
                      "kind": "LinkedField",
                      "name": "mostRecentAuction",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "NftItemTile_nftAuction"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftCmsExhibitionPage",
  "abstractKey": null
};

(node as any).hash = "3e55a4f877833b1891b77a6b335c552e";

export default node;
